export const USER_SETTINGS = 'user_settings';
export const LOCAL_USER_DATA = 'user_data';
export const REMEMBER_ME_DATA = 'remember_me_data';
export const REMEMBER_BIOMETRICS_DATA = 'remember_biometrics_data';
export const HAS_BIOMETRICS = 'has_biometrics';

export const AGREEMENT_TYPES = {
    TOS: 'TERMS_OF_SERVICE',
    PRIVACY: 'PRIVACY_NOTICE',
};
export const HAS_BEEN_ASKED_FOR_BIOMETRICS = 'has_been_asked_for_biometrics';
export const HAS_LOGGED_OUT = 'has_logged_out';
export const CST_EMAIL = 'BLSupport@eaton.com';
export const CST_EMAIL_EMEA = 'blsupportemea@eaton.com';
export const CST_PHONE_NUMBER = '1-877-ETN-CARE';
export const PACKAGE_NAME = 'com.eaton.brightlayerrmd';

export const MIN_DRAWER_WIDTH = 72;
export const MAX_DRAWER_WIDTH = 600;
export const DEFAULT_DRAWER_WIDTH = 360;
export const MAX_POWER_ON_DELAY = 255;
export const ORG_NAME_LIMIT = 50;

export const SHORT_GROUP_NAME_LENGTH_LIMIT = 6;
export const GROUP_NAME_LENGTH_LIMIT = 24;
export const LOAD_NAME_LENGTH_LIMIT = 50;

export const TAGS_LIMIT = 6;
export const TAG_LIMIT = 16;
export const ACCOUNT_ID_LIMIT = 32;
export const DEVICE_FIELDS_LIMIT: any = {
    productId: 6,
    serialNumber: 18,
    description: 256,
    deviceName: 32,
    guid: 36,
};

export const DEVICE_CHIPS: any = {
    deviceStatus: 'COMMON:STATUS',
    connectionStatus: 'COMMON:STATUS',
    groups: 'COMMON:GROUP',
    tags: 'COMMON:TAG_S',
    deviceName: 'DEVICES:DEVICE_NAME',
    parentId: 'COMMON:GATEWAY',
    modelCategory: 'COMMON:TYPE',
};
export const USER_DETAILS_LIMIT = 50;
export const PHONE_NUMBER_LIMIT = 10;
export const DELETE_KEY = 6;
export const guidRegex = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i;
export const NUMBER_REGEX = /^\d+$/;
export const DECIMAL_REGEX = /^-?[0-9]\d*(\.\d+)?$/;
// eslint-disable-next-line no-useless-escape
export const TEXT_FIELD_INVALID_CHARS_REGEX = /["';`<>\\$&\(\)\{\}\[\]\|\?\*\+=#]/;
export const ROLE_NAME_LIMIT = 20;
export const ROLE_DESCRIPTION_LIMIT = 256;
export const CUSTOMER_NAME_COMMENTS_LIMIT = 32;
export const CUSTOMER_COMMENTS_TEXT_LIMIT = 500;

export const PXDBP = 'pxdbp';
export const PXDBL = 'pxdbl';
export const PXIG = 'pxig';
export const BLG300 = 'blg300';

// FIJI-70579: Gateway models allowed as a parent in the Add Device picker.
export const ADD_DEVICE_ALLOWED_PARENT_GATEWAY_MODELS: string[] = [BLG300];

// Returns true if `model` is an allowed parent gateway (case/whitespace tolerant).
export const isAddDeviceAllowedParentGateway = (model: unknown): boolean => {
    if (typeof model !== 'string' || !model.trim()) return false;
    const normalized = model.trim().toLowerCase();
    return ADD_DEVICE_ALLOWED_PARENT_GATEWAY_MODELS.some((m) => m.toLowerCase() === normalized);
};
export const BLUEPRINT_ORGANIZATION_NAME = 'BLI Pre Production Test';
export const VENDOR_NAME = 'sierra';
export enum MasterDataKey {
    STARFISH = 'starfishchilddevices',
    DEVICETYPES = 'devicetypes',
}
export const MASTERDATA_DEVICE_TYPE = {
    gateway: 'gateway',
    child: 'child',
};

export const UI_METATADATA_DEVICE_TYPE = {
    gateway: 'Gateway',
    child: 'Child',
};

export const FORM_ELEMENT = {
    deviceType: 'deviceType',
};

export const VENDOR_TYPE_NAME = 'Starfish';

export const DEVICE_CATEGORY = {
    gateway: 'gateway',
    child: 'child',
    standalone: 'standalone',
    card: 'card',
};

export const UPS_DEVICE_TYPE_KEY = 'UPS';

export const ALLOWED_UPS_DEVICE_TYPES = [DEVICE_CATEGORY.standalone, DEVICE_CATEGORY.card];

export const GATEWAY_VENDOR = {
    starfish: 'starfish',
    sierra: 'sierra',
    dashboard: 'dashboard',
    generic: 'generic',
    machinegateway: 'machinegateway',
};

export const TIME_BTN = [
    {
        btnName: '24 Hours',
        btnValue: 24,
    },
    {
        btnName: '15 Days',
        btnValue: 360,
    },
    {
        btnName: '31 Days',
        btnValue: 744,
    },
];

export const ACKNOWLEDGE_TIMELINE_LIMIT = 256;
export const UPCOMING_OPEN_STATUS = 'OPEN';
export const UPCOMING_ACKNOWLEDGED_STATUS = 'ACKNOWLEDGED';
export const UPCOMING_PENDING_STATUS = 'PENDING';
export const UPCOMING_CLOSED_STATUS = 'CLOSED';

export const TAG_NAME_LIMIT = 16;
export const DEFAULT_HIERARCHY_SIZE = 25;
export const WIDGET_NAME_LIMIT = 32;
export const CHANNEL_NAME_LIMIT = 32;
export const WIDGET_DESCRIPTION_LIMIT = 128;
export const ENTITLEMENT_NAME_LIMIT = 32;
export const ENTITLEMENT_DESCRIPTION_LIMIT = 256;
export const PROPERTY_WIDGET_NAME_DESCRIPTION = 256;
export { BRANDING_COLOR_PALLETE } from './palette';

export const GRID_COLS = 50;
export const GRID_ROWS = 50;
export { mapStyles } from './mapThemeStyle';
export const seriesColors: string[] = [
    '#0088F2',
    '#F0CB2F',
    '#F47721',
    '#39B620',
    '#983FEF',
    '#004B9E',
    '#87C6D4',
    '#9C0E33',
    '#008A7E',
    '#774E08',
];

// Names of frequently used colors from : https://www.favocolor.com/hex/424e544d

export const AuroMetalSaurus = '#727E84';
export const MadderLake = '#CA3C3D';
export const OceanBoatBlue = '#007BC1';
export const Marigold = '#F0AA1F';
export const LightBlue = '#B3D7EC';
export const VividTangelo = '#F47721';
export const White = '#FFFFFF';
export const BrightGray = '#EEF0F0';
export const OuterSpace = '#424E54';

export const CHANNEL_PROFILE_NAME_LIMIT = 24;
export const CHANNEL_PROFILE_DESCRIPTION_LIMIT = 200;

// SQL
export const SQL = {
    ASC: 'ASC',
    DESC: 'DESC',
};
export const HIERARCHICAL_SORT_ORDER = 'HIERARCHY';

export function isValidLatLng(value: string, type: 'lat' | 'lng'): boolean {
    if (value === '' || value === '-' || value === '.' || value === '-0.') {
        return true;
    }

    if (!/^-?\d*(\.\d*)?$/.test(value)) {
        return false;
    }

    if (value.endsWith('.')) {
        return true;
    }

    const num = Number(value);
    if (!Number.isFinite(num)) {
        return false;
    }

    return type === 'lat' ? num >= -90 && num <= 90 : num >= -180 && num <= 180;
}

// Okta language mapping
export const fijiToOktaLanguageMap = {
    'en-US': 'en',
    'fr-FR': 'fr',
    'de-DE': 'de',
    'it-IT': 'it',
    'es-ES': 'es',
    'pt-PT': 'pt-BR',
    'nl-NL': 'nl-NL',
    'nb-NO': 'nb',
    'fr-CA': 'fr',
};
export const MANUFACTURER = 'Eaton';
export const LOCATION_TYPE = 'Organization';

// Common
export const CSV = 'CSV';
export const SMS = 'SMS';
export const EMAIL = 'EMAIL';
export const PHONECALL = 'PHONECALL';

export const CRITICAL = 'CRITICAL';
export const WARNING = 'WARNING';
export const MINOR = 'MINOR';
export const MAJOR = 'MAJOR';
export const INFORMATIONAL = 'INFORMATIONAL';

export const FILTER_ALARM_ACTIVE = 'Alarm Active';
export const FILTER_LOW_WARNING = 'Low Warning';
export const FILTER_WARNING_ACTIVE = 'Warning Active';

export const TIME_FORMAT_LT = 'LT';
export const DATE_FORMAT_MMDDYY = 'MM/DD/YY';
export const DATE_FORMAT_MMDDYYYY = 'MM/DD/YYYY';
export const CADENCE = [0, 1, 2, 3];

export const MANAGE_CHANNEL_SELECTIONS_PERMISSION = 'manage-channel-selections';

// Status colors for map pins
export const STATUS_COLORS = {
    SNOOZED: '#983FEF',
    ALARM: '#CA3C3D',
    OFFLINE: '#69B1C3',
    WARNING: '#F0AA1F',
    NORMAL: '#007BC3',
    QUARANTINED: '#945D83',
};

// Priority order for status colors (higher index = higher priority)
export const STATUS_PRIORITY = ['NORMAL', 'WARNING', 'OFFLINE', 'ALARM', 'SNOOZED', 'QUARANTINED'];

// Feature Flags
export const ENTITLEMENTS_V2_FEATURE_FLAG = 'entitlements/v2';
export const DEVICE_COUNT_TOGGLE_FEATURE_FLAG = 'device-count-toggle';
export const EXPORT_RAW_DATA_FEATURE_FLAG = 'DataActDataDownload';
export const ICON_LIBRARY_FEATURE_FLAG = 'iconlibrary';
export const END_USER_LICENSE_ACTIVATION_FEATURE_FLAG = 'EndUserLicenceActivation';
export const TRIAL_TO_PAID_SUBSCRIPTION_FEATURE_FLAG = 'trial-to-paid-subscription';

// Responsive Layout
export {
    WIDGET_CONTAINER_PADDING,
    SMALL_PHONE_BREAKPOINT,
    MEDIUM_PHONE_BREAKPOINT,
    HERO_WIDTH_SMALL,
    HERO_WIDTH_MEDIUM,
    HERO_WIDTH_LARGE,
    getEstimatedHeroWidth,
    calculateItemsPerRow,
} from './responsiveLayout';
export const TOS_PRIVACY_FEATURE_FLAG = 'agreement';

export * from './capacitorEvidence';
